import axios from 'redaxios';

import {makeGridSwatches} from '../features/swatch';
import {register} from '../vendor/theme-scripts/theme-sections';
import hideElement from '../util/hide-element';
import slideDown from '../util/slide-down';
import {Slider} from '../features/product-slider';

const selectors = {
  pagination: '[data-ajax-pagination]',
};

class FeaturedBlog {
  constructor(section) {
    this.section = section
    this.sectionId = section.id
    this.container = section.container
    this.initAjaxPagination()
  }

  initAjaxPagination() {

    this.container.addEventListener(
      'click',
      function (e) {
        const pageniation = e.target.closest(`[data-ajax-pagination]`)
        if( pageniation ) {
          e.preventDefault()
          const href = e.target.closest('a').getAttribute(`href`)
          this.fetch(href)
        }
      }.bind(this)
    )
  }

  fetch( requestUrl ) {
    const container = this.container
    const sectionId = this.sectionId

    axios
      .get(requestUrl)
      .then(function (response) {
        const fresh = document.createElement('div')
        fresh.innerHTML = response.data
        const inner = fresh.querySelector(`[data-section-id="${sectionId}"]`)

        if (inner.querySelector(`[data-ajax-items]`)) {
          const innerHtml = inner.querySelector(`[data-ajax-items]`).innerHTML
          container.querySelector(`[data-ajax-items]`).innerHTML = innerHtml
        }

        if (inner.querySelector(`[data-ajax-pagination]`)) {
          const innerHtml = inner.querySelector(`[data-ajax-pagination]`).innerHTML
          container.querySelector(`[data-ajax-pagination]`).innerHTML = innerHtml
        }

      })
      .catch(function (error) {
        console.warn(error)
      })
  }
}

const featuredBlog = {
  onLoad() {
    this.section = new FeaturedBlog(this);
  },
};

register('featured-blog', [featuredBlog]);
